<template>
  <PrimeVueToast>
    <template #icon>
      <IconSuccess />
    </template>
    <template #closeicon>
      <IconClose />
    </template>
  </PrimeVueToast>
</template>

<script setup lang="ts">
import PrimeVueToast from 'primevue/toast';

import IconSuccess from '@/icons/toast/IconSuccess.svg?component';
import IconClose from '@/icons/toast/IconClose.svg?component';
</script>
